var React = require('react');

function FbWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","fillRule":"evenodd","d":"M86.393 18.866v-8.595h2.935l.419-3.354h-3.354v-2.1c0-.943.314-1.677 1.677-1.677h1.782V.1c-.419 0-1.467-.1-2.62-.1a4.046 4.046 0 0 0-4.3 4.4v2.517H80v3.354h2.935v8.594z","transform":"translate(-80)"}));
}

FbWhite.defaultProps = {"width":"9.852","height":"18.866","viewBox":"0 0 9.852 18.866"};

module.exports = FbWhite;

FbWhite.default = FbWhite;
